<template>
  <div class="manufacturer">
    <img :src="manufacturer.img" alt="厂家图片">

  </div>
</template>
<script>
export default {
  props: {
    manufacturer: {
      type: Object,
      default: null
    }
  }
}
</script>
<style scoped>
.manufacturer {
  margin-left: 33px;
  margin-top: 10px;
  height: 100px;
  width: 200px;
  border: 5px solid #d7d7d7;
}
img{
  width: 100%;
  height: 100%;

}
</style>
